import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'components/modals';
import {FormLayout, DatePicker} from 'components';

const EditDatesModal = observer(({uiState, isOpen}) => {
  const {selectedReviewee, errors} = uiState;

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => uiState.closeEditDatesModal()}
      size='sm'
      title='performance_reviews.view.Update Review Dates'
    >
      <FormLayout>
        <DatePicker
          className='full-width'
          label='performance_reviews.view.Launch Date'
          onChange={date => selectedReviewee.launchDate = date}
          value={selectedReviewee.launchDate}
          errorMessage={errors.launchDate}
        />
        <DatePicker
          className='full-width'
          label='performance_reviews.view.Due Date'
          onChange={date => selectedReviewee.dueDate = date}
          value={selectedReviewee.dueDate}
          errorMessage={errors.dueDate}
        />
      </FormLayout>
      <ModalButtons
        saveCaption={'performance_reviews.view.Update'}
        onSave={() => uiState.updateDates()}
        onCancel={() => uiState.closeEditDatesModal()}
      />
    </Modal>
  );
});

export default EditDatesModal;
